import { BigNumber } from 'ethers'
import { useMemo } from 'react'
import { toBigNumber } from '~/lib/helpers'
import { SIS_DECIMALS } from '~/lib/SISDecimals'

export function useToBigNumber(value: string): BigNumber | undefined {
	return useMemo(() => {
		try {
			return toBigNumber(SIS_DECIMALS, value)
		} catch {
			//
		}
	}, [value])
}
